
import React, {useEffect, useRef, useState} from "react";
import { properties } from "../../../config/properties";
import {useLocation, useNavigate} from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Container,
    Icon,
    Row,
    Table,
    Pager,
    PagerItem,
    PagerLink, Dimmer, Label, Modal, Alert, TextArea, Input, GoBack
} from "design-react-kit";

import Spinner from "../../layout/Spinner";

// Stili unificati, riutilizzati dall'esempio fornito
const styles = {
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '90vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    formContainer: {
        backgroundColor: '#ffffff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.07)',
        border: '1px solid #dee2e6'
    },
    formTitle: {
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#333',
        marginBottom: '1.5rem',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
    },
    highlightedRow: {
        backgroundColor: 'rgba(0, 102, 204, 0.1)',
        transition: 'background-color 0.3s ease-in-out',
    }
};

// --- Componente per il Form di Modifica Delega ---
const FormModificaDestinatario = ({destinatario, onSave, onCancel,user}) => {
    const [indirizzo, setIndirizzo] = useState('');
    const [descrizione, setDescrizione] = useState('');
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (destinatario) {
            setIndirizzo(destinatario.indirizzo);
            setDescrizione(destinatario.descrizione || ''); // Gestisce il caso in cui le note siano null
        }
    }, [destinatario]);

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setError(null);

        try {


            const response = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/update/destinatarioMail`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({descrizione, indirizzo, id: destinatario.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente})
            });

            if(response.status === 401){

                const datasResponse = await response.json();

                setError("Errore di comunicazione con il server.");

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const result = await response.json();
            if (result.esito === "OK") {
                onSave(); // Notifica il successo al componente genitore
            } else {
                setError(result.messaggio || "Operazione fallita");
            }
        } catch (err) {
            setError("Errore di rete o server non raggiungibile.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!destinatario) return null;

    return (
        <div style={styles.formContainer}>
            <h3 style={styles.formTitle}>Modifica Destinatario</h3>
            {error && <Alert color="danger">{error}</Alert>}
            <form onSubmit={handleConfirm}>
                <Input
                    id="indirizzo"
                    label="Indirizzo destinatario"
                    value={indirizzo}
                    style={{color:'#1a1a1a', fontWeight:'700'}}
                    onChange={(e) => setIndirizzo(e.target.value)}
                    required
                    maxLength={500}

                />
                <Input
                    id="descrizione"
                    label="Descrizione (opzionale)"
                    value={descrizione}
                    style={{color:'#1a1a1a', fontWeight:'700'}}
                    onChange={(e) => setDescrizione(e.target.value)}
                    maxLength={500}
                />
                <div className="mt-4" style={styles.buttonGroup}>
                    <Button className="btn btn-outline-secondary" outline type="button" onClick={onCancel}>
                        Annulla
                    </Button>
                    <Button className="btn btn-outline-primary" type="submit" disabled={isSaving}>
                        {isSaving ? 'Salvataggio...' : 'Salva'}
                    </Button>
                </div>
            </form>
        </div>
    );
};


const ElencoDestinatariMail = ({user}) => {

    const initialLimit = 10;
    const initialOffset = 0;

    const [limit, setLimit] = useState(initialLimit);
    const [offset, setOffset] = useState(initialOffset);
    const [destinatari, setDestinatari] = useState([]);
    const [totalElements, setTotalElements] = useState(0);

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const [sortField, setSortField] = useState("indirizzo");
    const [sortDirection, setSortDirection] = useState("asc"); // default: ascendente

    const [destinatarioToDelete, setDestinatarioToDelete] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [destinatarioInModifica, setDestinatarioInModifica] = useState(null);

    const [loadingUser, setLoadingUser] = useState(true);

    const navigate = useNavigate();
    const location = useLocation();

    const totalPages = Math.ceil(totalElements / limit);
    const currentPage = Math.floor(offset / limit) + 1;

    const [fileBase64, setFileBase64] = useState(null);
    const [fileName, setFileName] = useState(null);

    const fileInputRef = useRef(null);



    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        // Reset predefinito
        setFileName(null);
        setFileBase64(null);

        if (!file) return;

        // Controllo estensione
        if (!file.name.toLowerCase().endsWith(".csv")) {

            setAlert({
                visible: true,
                type: 'warning',
                message: "È necessario caricare un file in formato CSV."
            });

            // Pulisco input
            event.target.value = "";
            return;
        }

        // Se è CSV → lo leggo
        setAlert({ visible: false, type: '', message: '' });

        setFileName(file.name);

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1];
            setFileBase64(base64String);
        };
        reader.readAsDataURL(file);
    };



    const uploadCsv = async () => {
        if (!fileBase64 || !fileName) return;

        setAlert({ visible: false, type: '', message: '' });

        try {
            const res = await fetch(properties.fullBaseUrl + properties.baseAppUrl + "/std/service/aggiuntaDestinatariCsv", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    filename: fileName,
                    fileBase64: fileBase64,
                    userID: user.userID,
                    cciaa: user.cciaa,
                    gruppoUtente: user.gruppoUtente
                })
            });

            if(res.status === 401){
                const datasResponse = await res.json();
                setAlert({ visible: true, type: 'danger', message: 'Errore di comunicazione con il server.' });
                setTimeout(() => window.location.href = datasResponse.redirectUrl, 10);
                return;
            }

            const result = await res.json();

            if(result.esito === "OK"){
                await getDestinatariMail({ offset, limit, sortField, sortDirection, userID: user.userID, cciaa: user.cciaa, gruppoUtente: user.gruppoUtente });
                setAlert({ visible: true, type: 'success', message: `${result.messaggio} Totale aggiunti: ${result.totalAdds}; Respinti: ${result.respinti}.` });

                // 🔥 RESET COMPLETO
                setFileBase64(null);
                setFileName(null);

                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

            } else {
                setAlert({ visible: true, type: 'danger', message: result.messaggio || 'Errore durante l\'upload' });
                setFileBase64(null);
                setFileName(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            }
        } catch (e) {
            setAlert({ visible: true, type: 'danger', message: 'Errore durante l\'operazione di aggiunta dei destinatari.' });
            setFileBase64(null);
            setFileName(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    // Gestisce i messaggi provenienti da altre pagine
    useEffect(() => {
        if (location.state?.esito) {
            window.scrollTo({top: 0, behavior: 'smooth'});
            const message = location.state.esito.messaggio;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({visible: true, type, message});
        }

    }, [location.state]);


    useEffect(() => {
        getDestinatariMail({
            offset,
            limit,
            sortField,
            sortDirection,
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente
        });
    }, [offset, limit, sortField, sortDirection]);


    const handleEditClick = (destinatario) => {
        setDestinatarioInModifica(destinatario);
        setAlert({visible: false});
    };

    const handleCancelEdit = () => {
        setDestinatarioInModifica(null);
    };

    const handleSaveSuccess = () => {
        setDestinatarioInModifica(null);

        getDestinatariMail({
            offset,
            limit,
            sortField,
            sortDirection,
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente
        });
        setAlert({visible: true, type: 'success', message: 'Destinatario aggiornata con successo!'});
    };


    const handleSort = (field) => {
        if (sortField === field) {
            // Se clicco la stessa colonna, inverto l'ordine
            setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortDirection("asc"); // reset a asc se è una nuova colonna
        }
    };

    const openDeleteConfirm = (destinatario) => {
        setDestinatarioToDelete(destinatario);
        setShowConfirmModal(true);
    };

    const closeDeleteConfirm = () => {
        setDestinatarioToDelete(null);
        setShowConfirmModal(false);
    };

    const confirmDelete = async () => {
        if (!destinatarioToDelete) return;
        setAlert({ visible: false});


        try {
            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/delete/destinatarioMail`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: destinatarioToDelete.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const json = await res.json();

            if (json.esito === "OK") {

                await getDestinatariMail({
                    offset,
                    limit,
                    sortField,
                    sortDirection,
                    userID: user.userID,
                    cciaa: user.cciaa,
                    gruppoUtente:user.gruppoUtente
                });
                window.scrollTo({top: 0, behavior: 'smooth'});

                setAlert({ visible: true, type: 'success', message: json.messaggio });

            } else {
                window.scrollTo({top: 0, behavior: 'smooth'});

                setAlert({ visible: true, type: 'danger', message: json.messaggio});
            }
        } catch (e) {
            window.scrollTo({top: 0, behavior: 'smooth'});

            setAlert({ visible: true, type: 'danger', message: 'Errore di comunicazione con il server.' });
        } finally {
            closeDeleteConfirm();
        }
    };



    const getDestinatariMail = async (params) => {
        try {
            setLoadingUser(true);

            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/getDestinatariMail",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setDestinatari([]);
                setTotalElements(0);

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const data = await res.json();

            if(data.esito === "OK"){
                setTotalElements(data.totalElements);
                setDestinatari(data.destinatari);
            }else{
                setAlert({ visible: true, type: 'danger', message: data.errore.toString()});
                setTotalElements(0);
                setDestinatari([]);

            }


        } catch (e) {

            setAlert({ visible: true, type: 'danger', message: "Errore del server."});
            setDestinatari([]);
            setTotalElements(0);

        }finally {
            setLoadingUser(false);
        }
    };


    const handleLimitChange = (newLimit) => {
        setLimit((prev) => {
            // React garantirà che il nuovo limit venga impostato prima del useEffect
            return newLimit;
        });
        setOffset(0); // questo causerà il useEffect a triggerarsi con offset 0 e nuovo limit
    };

    const handlePageChange = (page) => {
        const newOffset = (page - 1) * limit;
        setOffset(newOffset);
    };

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <Spinner active/>


            </Container>
        );


    }

    const renderPagination = () => {
        const pages = [];

        let startInd =  (currentPage-1) > 0 ? currentPage-1 : 1
        let endInd =  (currentPage+1) < totalPages ? currentPage+1 : totalPages


        if(currentPage > 2){
            pages.push(
                <PagerItem
                    key={1}
                    active={1 === currentPage}
                    className={1 === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={1 === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(1);
                        }}
                    >
                        {1}
                    </PagerLink>
                </PagerItem>
            );
            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );
        }

        for (let i =  startInd  ; i <= endInd  ; i++) {


            pages.push(
                <PagerItem
                    key={i}
                    active={i === currentPage}
                    className={i === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={i === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(i);
                        }}
                    >
                        {i}
                    </PagerLink>
                </PagerItem>
            );


        }

        if(currentPage < totalPages-2){

            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );

            pages.push(
                <PagerItem
                    key={totalPages}
                    active={totalPages === currentPage}
                    className={totalPages === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={totalPages === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(totalPages);
                        }}
                    >
                        {totalPages}
                    </PagerLink>
                </PagerItem>
            );
        }
        return (
            <Pager className="mt-3 justify-content-center" aria-label="Navigazione elenco destinatari">
                <PagerItem disabled={currentPage === 1}>
                    <PagerLink
                        previous
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                        }}
                    >
                        <Icon icon="it-chevron-left" />
                    </PagerLink>
                </PagerItem>

                {pages}

                <PagerItem disabled={currentPage === totalPages}>
                    <PagerLink
                        next
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                        }}
                    >
                        <Icon icon="it-chevron-right" />
                    </PagerLink>
                </PagerItem>
            </Pager>
        );
    };

    return (
        <Container className="bg-white py-3 py-lg-6">
            {/* Card parametri di ricerca */}

            <div style={{display: "flex"}}>
                <div style={{flex: 1}}>
                    <h2 className="mb-5 ">Elenco Destinatari Mail</h2>
                </div>

            </div>

            <div style={{flex: 1}} align={"right"} className={"mb-5"} >

                <Button className="btn btn-outline-primary" outline onClick={() => navigate('/private/inviaMail')}>
                    Indietro
                </Button>
            </div>

            {/* parte nuova sostitutiva */}
            <Row>

                {(
                    <Col md={4} hidden={destinatarioInModifica} className="transition-all duration-300">
                        <Container>

                            <div className="guidance-box lead">
                                <p>

                                    {/* Dropdown per selezionare il limite */}
                                    <Row className="mb-3 ">
                                        <Col xs="auto">
                                            <Label htmlFor="limit-select" className="mb-0"><strong>Righe per
                                                pagina:</strong>

                                                <select
                                                    id="limit-select"
                                                    value={limit}
                                                    onChange={(e) => handleLimitChange(Number(e.target.value))}
                                                    className="form-select m-3"
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </Label>

                                        </Col>

                                    </Row>
                                </p>

                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1, padding: "1.68%"}} align={"right"}>
                                        <Button
                                            className="btn btn-outline-primary"
                                            outline
                                            onClick={uploadCsv}
                                            disabled={!fileBase64}
                                        >
                                            Inserisci file CSV destinatari
                                        </Button>
                                    </div>
                                    <div style={{flex: 1, padding: "1.68%"}} align={"left"}>
                                        <Button className="btn btn-outline-primary" outline onClick={() => {
                                            navigate('/private/inserimentoDestinatarioMail')
                                        }}>
                                            Inserisci destinatario
                                        </Button>
                                    </div>

                                </div>
                                <div className={"mt-4"}>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        //onChange={(e) => handleFileUpload(e)}
                                        onChange={handleFileUpload}
                                        accept=".csv"
                                        style={{fontSize:"medium"}}
                                    />
                                </div>


                            </div>

                        </Container>
                    </Col>
                )}

                <Col md={destinatarioInModifica && 8} className="transition-all duration-300">

                    {alert.visible && (
                        <Alert color={alert.type} isOpen={alert.visible}
                               toggle={() => setAlert({...alert, visible: false})}>
                            {alert.message}
                        </Alert>
                    )}


                    <Table hover>
                        <thead>
                        <tr>
                            <th scope="col" className="text-center" style={{display: "none"}}>#</th>
                            <th scope="col" className="text-left" style={{...styles.tableHeader, width: '45%'}}
                                onClick={() => handleSort("indirizzo")}>
                                INDIRIZZO{" "}
                                {sortField === "indirizzo" ?
                                    <Icon color={"white"}
                                          icon={sortDirection === "asc" ? "it-arrow-up-triangle" : "it-arrow-down-triangle"}/>
                                    :
                                    <Icon color={"white"} icon={"it-minus"}/>
                                }
                            </th>
                            <th scope="col" className="text-left" style={{...styles.tableHeader, width: '40%'}}
                                onClick={() => handleSort("descrizione")}>
                                Descrizione{" "}
                                {sortField === "descrizione" ?
                                    <Icon color={"white"}
                                          icon={sortDirection === "asc" ? "it-arrow-up-triangle" : "it-arrow-down-triangle"}/>
                                    :
                                    <Icon color={"white"} icon={"it-minus"}/>
                                }
                            </th>
                            <th scope="col" className="text-left" style={{...styles.tableHeader, width: '15%'}}>Azioni
                            </th>
                        </tr>
                        </thead>
                    </Table>
                    <div style={styles.tableContainer} className="custom-scrollbar">
                        <Table hover>

                            <tbody className="bg-white">
                            {destinatari.length > 0 ? (
                                destinatari.map((destinatario, index) => (
                                    <tr key={index}>
                                        <td scope="row" className="text-center"
                                            style={{display: "none"}}>{offset + index + 1}</td>
                                        <td className="text-left" style={{
                                            ...styles.tableRowText,
                                            width: '45%',
                                            height: "100px"
                                        }}>{destinatario.indirizzo}</td>
                                        <td className="text-left" style={{
                                            ...styles.tableRowText,
                                            width: '40%',
                                            height: "100px"
                                        }}>{destinatario.descrizione}</td>
                                        <td className="text-left"
                                            style={{...styles.tableRowText, width: '15%', height: "100px"}}>
                                            <button className={"action-icon"} style={styles.actionButton}
                                                    aria-label={`Modifica ${destinatario.indirizzo}`}
                                                    onClick={() => handleEditClick(destinatario)}
                                            >
                                                <Icon icon="it-pencil" color="primary"/>
                                            </button>
                                            <button className={"action-icon"} style={styles.actionButton}
                                                    aria-label={`Elimina ${destinatario.indirizzo}`}
                                                    onClick={() => openDeleteConfirm(destinatario)}>
                                                <Icon icon="it-delete" color="danger"/>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" style={styles.tableRowText} colSpan="8">
                                        Nessun risultato trovato
                                    </td>
                                </tr>
                            )}
                            </tbody>

                        </Table>
                    </div>


                    {destinatari.length > 0 && (
                        <>
                            <Row className="mt-2">
                                <Col className="text-end">
                                    <small className="text-muted">
                                        Visualizzati
                                        da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                                    </small>
                                </Col>
                            </Row>
                            {totalPages > 1 && renderPagination()}
                        </>
                    )}

                </Col>

                {/* Colonna Destra: Form di Modifica (visibile condizionalmente) */}
                {destinatarioInModifica && (
                    <Col md={4} className="transition-all duration-500">
                        <FormModificaDestinatario
                            destinatario={destinatarioInModifica}
                            onSave={handleSaveSuccess}
                            onCancel={handleCancelEdit}
                            user={user}
                        />


                    </Col>
                )}

            </Row>

            <Spinner active={!setDestinatari}/>

            {/* Tabella risultati */}
            <Row className="justify-content-center">

            </Row>

            <Modal isOpen={showConfirmModal} toggle={closeDeleteConfirm} centered>
                <div toggle={closeDeleteConfirm}>Conferma Eliminazione</div>
                <div>
                    Sei sicuro di voler eliminare il seguente
                    destinatario: <strong>{destinatarioToDelete?.indirizzo}</strong>?
                    <br/>
                    L'azione non potrà essere annullata.
                </div>
                <div>
                    <Button color="secondary" outline onClick={closeDeleteConfirm}>Annulla</Button>
                    &nbsp;
                    <Button color="danger" onClick={confirmDelete}>Conferma ed Elimina</Button>
                </div>
            </Modal>
        </Container>
    );
};

export default ElencoDestinatariMail;
